import { Box } from '@jfs/ui-new'
import { SubmittingComponent } from '../../../../components/SubmittingComponent'

interface TableDataSubmissionInterface {
  toggleUploading?: (val: boolean) => void
  toggleSubmission?: (val: boolean) => void
  toggleReviewSelected?: (val: boolean) => void
  type: 'bulkUpload' | 'tid'
}

const TableDataSubmission = ({
  toggleUploading,
  toggleSubmission,
  toggleReviewSelected,
  type,
}: TableDataSubmissionInterface) => {
  //TODO: Remove it
  // useEffect(() => {
  //   setTimeout(() => {
  //     toggleUploading && toggleUploading(false)
  //     toggleSubmission && toggleSubmission(true)
  //     toggleReviewSelected && toggleReviewSelected(false)
  //   }, 3000)
  // }, [toggleReviewSelected, toggleSubmission, toggleUploading])

  return (
    <Box flex={1}>
      <SubmittingComponent type={'submit'} screenType={type} />
    </Box>
  )
}

export default TableDataSubmission
